export default {
  "nav.brand": "USFANSLINK",
  "nav.home": "Home",
  "nav.guide": "Complete Guide",
  "nav.shoppingGuide": "Shopping Guide",
  "nav.visitMain": "Visit Main Website",

  "hero.eyebrow": "USFANS Spreadsheet Resource",
  "hero.title": "USFANS Spreadsheet — Find Products, Sellers & Buying Resources Faster",
  "hero.subtitle": "Looking for the USFANS spreadsheet? Explore organized product resources, seller information, buying guides, QC tips, shipping information, warehouse resources and the latest USFANS updates — all in one place.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "buy it now",
  "hero.trust": "Independent informational resource • Updated regularly • Built for easier product research",

  "dropdown.label": "Browse categories",
  "dropdown.placeholder": "Choose a category…",

  "categories.title": "Shop by Category",
  "categories.subtitle": "Jump straight to any product category on the main website. Every link opens in a new tab.",
  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies / Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants / Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "Underwear / Underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",
  "categories.open": "Open",

  "features.title": "Everything You Need to Navigate the USFANS Spreadsheet",
  "features.subtitle": "A single organized resource that helps you move from browsing to a confident decision.",
  "features.f1.title": "Find Products Faster",
  "features.f1.text": "Discover organized product and category resources without wasting time searching through scattered information.",
  "features.f2.title": "Compare Sellers",
  "features.f2.text": "Learn what to check when evaluating sellers, product information and available resources.",
  "features.f3.title": "Understand Shipping",
  "features.f3.text": "Explore USFANS shipping information, shipping costs, methods and important considerations before ordering.",
  "features.f4.title": "Check Before You Buy",
  "features.f4.text": "Use QC, warehouse, safety and buying guides to make better-informed decisions.",

  "teaser.eyebrow": "Featured Guide",
  "teaser.title": "The Complete USFANS Spreadsheet Guide",
  "teaser.text": "Learn what the USFANS spreadsheet is, how to use it, and what to check before you buy — from seller research to shipping, quality control and safety.",
  "teaser.cta": "Read the Complete Guide",

  "faq.title": "USFANS Spreadsheet FAQ",
  "faq.q1": "What is the USFANS spreadsheet?",
  "faq.a1": "It is an organized resource that groups product categories, seller notes and buying information into a single structured list, so you can explore products faster instead of searching page by page.",
  "faq.q2": "How do I use the USFANS spreadsheet?",
  "faq.a2": "Start with the category you need, read the seller notes, compare a few options, check the shipping details, then open the product link in a new tab to continue on the main website.",
  "faq.q3": "Is USFANS legit?",
  "faq.a3": "We are an independent resource and cannot verify every seller or product. Always check current information, reviews and shipping terms yourself before making a purchase.",
  "faq.q4": "How much does USFANS shipping cost?",
  "faq.a4": "Shipping costs change depending on destination, weight and method, so we do not publish fixed prices here. Check the current shipping information on the main website before ordering.",

  "cta.title": "Ready to Explore the USFANS Spreadsheet?",
  "cta.text": "Start with the spreadsheet hub, explore the latest guides and compare useful resources before visiting the main website.",
  "cta.primary": "Explore USFANS Spreadsheet",
  "cta.secondary": "Read the Guide",

  "footer.disclaimerTitle": "Disclaimer",
  "footer.disclaimer": "This website is an independent informational resource. We do not guarantee sellers, products, shipping outcomes, refunds, transactions or delivery times. Always verify current information before making a purchase.",
  "footer.explore": "Explore",
  "footer.company": "Company",
  "footer.guide": "Complete Guide",
  "footer.rights": "All rights reserved.",
  "footer.language": "Language",

  "guides.title": "USFANS Guides & Resources",
  "guides.subtitle": "Original, independent guides to help you research products, compare sellers and buy with confidence.",
  "guides.readMore": "Read guide",
  "article.notFound": "Guide not found",

  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.privacy": "Privacy Policy",
  "nav.editorial": "Editorial Policy",

  "contact.title": "Contact Us",
  "contact.subtitle": "Have a question or feedback? Send us a message and we will get back to you.",
  "contact.name": "Name",
  "contact.email": "Email",
  "contact.message": "Message",
  "contact.submit": "Send message",
  "contact.sending": "Sending...",
  "contact.success": "Thanks! Your message has been sent.",
  "contact.error": "Something went wrong. Please try again.",

  "article.reviewedBy": "Reviewed by",
  "article.lastUpdated": "Last updated",

  "notFound.title": "Page not found",
  "notFound.text": "The page you are looking for does not exist or has been moved.",
};